var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center flex-column full-height-class"},[_vm._m(0),_c('span',{staticClass:"font-weight-bold mt-3"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fa-solid fa-cog fa-spin fa-5x"}),_c('i',{staticClass:"fa-solid fa-cog fa-spin fa-5x",staticStyle:{"--fa-animation-direction":"reverse"}})])
}]

export { render, staticRenderFns }